/** * * Asynchronously loads the component for
User Profile
* */ import { lazyLoad } from "utils/loadable";
export const UserProfile = lazyLoad(
  () => import("./index"),
  (module) => module.UserProfile
);